import React, { useEffect } from 'react';
import data from './data.json';
// lotto data :  https://smok95.github.io/lotto/results/all.json

let allNumberList: number[][] = [];
function Lotto2() {
    const [numberList, setNumberList] = React.useState<number[][]>([]);
    const [lastDate, setLastDate] = React.useState<string | null>(null);

    useEffect(() => {
        getLottoNumbers();
        // makeData();
    }, []);

    //     const makeData = () => {
    //         const str = `아라벨라 페어차일드 (Arabella Fairchild)
    // 세레니티 루시드 (Serenity Lucid)
    // 벨 샴 (Belle Sham)
    // 한생화 (Han Saenghwa)
    // 여지은 (Yeo Jieun)
    // 찰리 호손 (Charlie Hawthorne)
    // 코니 라크스퍼(Connie Larkspur)
    // 로나 카일라니 (Rona Kaʻilani)
    // 이안세 (Lee An-Se)
    // 애쉬 스털링 (Ash Sterling)
    // 임수려 (Lim Sooryeo)
    // 임화려 (Lim Hwaryeo)
    // 마일런 오코넬 (Mylan O’Connell)
    // 베티 애쉬포드 (Betty[Elizabeth] Ashford)
    // 레라 (LERA)
    // 양세인 (Yang Se-In)
    // 한성우 (HAN SUNGWOO)
    // 에밀리아 윈슬렛 (Emilia Winslet)
    // 제시카 송 (Jessica Song)
    // 마니 (Mani)
    // 미라 브라이어 (Mira Briar)
    // 로레나 (Rorenna)
    // 차윤호 (CHA YUNHO)
    // 원찬현 (WON CHANHYUN)
    // 시에나 해링턴 (Sienna Harrington)
    // 마리솔 뒤몽 (Marisol Dumont)
    // 리앤 챔버레인 (Leanne Chamberlain)
    // 블레어 (BLAIR)
    // 리지 콜드웰 (Lizzy[Elizabeth] Caldwell)
    // 데몬 (Demon)
    // 헤일리 크림슨 (Hailey Crimson)
    // 오설아 (Oh Seol Ah)
    // 문채령 (Moon Chae Ryung)
    // 세실리아 문(Cecilia Moon)
    // 홍은결 (Hong Eunkyul)
    // 강시온 (Kang Sion)
    // 마일리 파일 (Miley Pile)
    // 엘리아스 파일 (Elias Pile)
    // 신시아 레이크 (Cynthia Lake)
    // 캔디 듀이 (Candy Dewy)
    // 세실 듀이 (Cecil Dewy)
    // 달리아 듀이 (Dahlia Dewy)
    // `;

    //         // 각행을 괄호를 기준으로 필드를 나누어 배열로 저장
    //         const rows = str.split('\n').map(row => {
    //             const [name, translation] = row.split(' (');
    //             if (!name || !translation) return null;

    //             console.log(name.trim(), '\t', translation.replace(')', '').trim());

    //             return {
    //                 name: name.trim(),
    //                 translation: translation.replace(')', '').trim(),
    //             };
    //         });

    //         // console.log(rows);
    //         return rows;
    //     };

    const getLottoNumbers = () => {
        // allNumberList = data.map((item: any) => item.numbers).flat();

        // 각 자리수 별로 배열로 만든다.
        allNumberList = [];
        for (let i = 0; i < 6; i++) {
            const unitNumbers: number[] = [];
            for (const item of data) {
                unitNumbers.push(item.numbers[i]);
            }
            allNumberList.push(unitNumbers);
        }

        console.log(allNumberList);
        const date = data[data.length - 1].date;
        // let drawNo = data[data.length - 1].draw_no;

        // asia/seoul
        let seoulDate = new Date(date).toLocaleString('ko-KR', {
            timeZone: 'Asia/Seoul',
        });
        // seoulDate = seoulDate.replace(/\./g, '-').replace(' ', '');

        // 날짜만 (앞자리 10자리)
        // seoulDate = `${drawNo}회 (${seoulDate.slice(0, 10)})`;
        seoulDate = date.slice(0, 10);
        console.log('last date: ', seoulDate);

        setLastDate(seoulDate);
    };

    const randomPopIndex = (list: number[]) => {
        const popLength = list.length;
        const randomIndex = Math.floor(Math.random() * popLength);
        console.log('randomPopIndex called, randomIndex: ', randomIndex);
        return randomIndex;
    };

    const popNumber = async () => {
        // allNumberList 에서 6개를 랜덤으로 뽑아 numberList에 추가

        const newNumbers: number[] = [];

        let loopCnt = 0;
        while (newNumbers.length < 6) {
            if (loopCnt > 1000) {
                console.log('loopCnt exceeded 100, breaking loop');
                break;
            }

            const i = newNumbers.length; // 0~5
            const index = randomPopIndex(allNumberList[i]);
            const num = allNumberList[i][index];

            // 이미 뽑힌 번호에 있으면 다시 뽑기
            if (newNumbers.includes(num)) {
                console.log('duplicate number found: ', num);
                continue;
            }

            newNumbers.push(num);
            // 뽑은 숫자는 allNumberList에서 제거
            allNumberList[i].splice(index, 1);

            loopCnt++;
        }
        console.log('popNumber called, newNumbers: ', newNumbers);

        // 오름차순 정렬
        newNumbers.sort((a, b) => a - b);
        setNumberList(prev => [...prev, newNumbers]);

        scrollToBottom();
    };

    const scrollToBottom = () => {
        setTimeout(() => {
            const contailer = document.querySelector('.numbers-list');
            if (contailer)
                contailer.scrollTo({
                    top: contailer.scrollHeight,
                    behavior: 'smooth',
                });
        }, 100);
    };

    const clearNumbers = () => {
        setNumberList([]);
    };

    const checkLine = (e: React.MouseEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        if (target.classList.contains('item-container')) {
            target.classList.toggle('checked');
        }
    };

    return (
        <>
            <div className="head">
                <div className="title">deus ex machina</div>
                <button className="clear" onClick={clearNumbers}>
                    clear
                </button>
            </div>
            <div className="numbers-list">
                {numberList.length > 0 &&
                    numberList.map((numbers, index) => (
                        <div
                            className="item-container"
                            key={index}
                            onClick={checkLine}
                        >
                            {numbers.map((number, i) => (
                                <div className="item" key={i}>
                                    {number}
                                </div>
                            ))}
                        </div>
                    ))}
            </div>
            <div className="button-area">
                <button className="btn-generate" onClick={popNumber}>
                    Generate Numbers
                </button>
                <div className="date">update: {lastDate}</div>
            </div>
        </>
    );
}

export default Lotto2;
